import { U21AiChatButtonInnerProps } from 'app/shared/u21-ui/components/input/chat/shared';

import { U21Button } from 'app/shared/u21-ui/components/input/U21Button';
import { U21TextField } from 'app/shared/u21-ui/components/input/text-field/U21TextField';
import { U21Spacer } from 'app/shared/u21-ui/components/layout/U21Spacer';
import { useState } from 'react';
import styled from 'styled-components';

export const U21AiChatButtonInner = ({
  choices,
  disabled,
  onSubmit,
}: U21AiChatButtonInnerProps) => {
  const [customText, setCustomText] = useState('');

  return (
    <U21Spacer spacing={1.5}>
      <ButtonRow horizontal spacing={1} useFlexGap>
        {choices.map((choice) => (
          <U21Button
            key={choice}
            variant="contained"
            color="primary"
            disabled={disabled}
            onClick={() => onSubmit(choice)}
          >
            {choice}
          </U21Button>
        ))}
      </ButtonRow>
      <U21Spacer horizontal>
        <U21TextField
          type="textarea"
          disabled={disabled}
          value={customText}
          onChange={(value: string) => setCustomText(value)}
          placeholder="Or type a response..."
          minRows={1}
        />
        <U21Button
          variant="contained"
          color="primary"
          disabled={!customText.trim()}
          onClick={() => onSubmit(customText.trim())}
        >
          Submit
        </U21Button>
      </U21Spacer>
    </U21Spacer>
  );
};

const ButtonRow = styled(U21Spacer)`
  flex-wrap: wrap;
`;
